import type { CityConfig } from "../city-template/types";

export const lasVegasConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Las Vegas",
  state: "Nevada",
  stateAbbr: "NV",
  slug: "las-vegas",
  route: "/cities/las-vegas",
  title: "Emergency Passport Las Vegas NV — Expedited 24-Hour Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Las Vegas, NV — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving convention delegates, entertainment industry professionals, Harry Reid International Airport travelers, UNLV students, and Clark County families. No Nevada passport agency — 270 miles to nearest.",
  h1: "Emergency & Expedited Passport Services in Las Vegas, NV",
  heroSubtitle: "CES badge in hand but passport just expired? Cirque production flying to Macau next week? International wedding party arriving from six countries? We help Las Vegas residents — from Strip hospitality pros to Summerlin families to convention exhibitors — get passports fast. As a registered U.S. Department of State courier, we offer rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20aerial%20view%20of%20the%20Las%20Vegas%20Strip%20at%20twilight%20with%20iconic%20neon%20hotel%20towers%20and%20casino%20resorts%20illuminated%20in%20brilliant%20warm%20gold%20magenta%20and%20electric%20colors%20against%20a%20deep%20purple%20desert%20sky%2C%20wide%20angle%20sweeping%20vista%20capturing%20the%20world%20famous%20entertainment%20district%20from%20above%2C%20dramatic%20cinematic%20photography%20with%20rich%20vibrant%20tones%20and%20glowing%20lights%2C%20no%20visible%20people%20or%20text%2C%20the%20energy%20and%20spectacle%20of%20the%20Nevada%20resort%20capital%20at%20dusk&width=1800&height=700&seq=las-vegas-hero-2026&orientation=landscape",
  heroImageAlt: "Las Vegas Nevada Strip skyline at twilight with vibrant neon casino towers illuminating the desert night",
  geoPosition: "36.1699;-115.1398",
  geoPlacename: "Las Vegas, Nevada",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Los Angeles Passport Agency",
    address: "11000 Wilshire Blvd Suite 1000, Los Angeles CA 90024",
    distance: "Approximately 270 miles — about 4 hours via I-15. No passport agency in Nevada.",
  },
  nearbyCitiesZips: [
    { name: "Downtown Las Vegas", zips: "89101, 89102, 89104" },
    { name: "Henderson", zips: "89002, 89014, 89015" },
    { name: "Summerlin", zips: "89135, 89138, 89144" },
    { name: "North Las Vegas", zips: "89030, 89031, 89032" },
    { name: "Sunrise Manor", zips: "89110, 89121" },
    { name: "Enterprise", zips: "89141, 89148, 89178" },
    { name: "Spring Valley", zips: "89103, 89117, 89146" },
    { name: "Paradise", zips: "89109, 89119, 89120" },
    { name: "Boulder City", zips: "89005, 89006" },
    { name: "Mesquite", zips: "89027, 89034" },
    { name: "Pahrump", zips: "89041, 89048" },
    { name: "Jean / Primm", zips: "89019" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Convention Emergency Processing", desc: "CES, SEMA, MAGIC, NAB exhibitor flying out this week? Reserved courier access gets your passport completed in as fast as 24 hours — no 270-mile drive to LA." },
    { icon: "ri-flight-takeoff-line", title: "LAS Airport Expertise", desc: "Harry Reid International handles 50M+ passengers to London, Tokyo, Seoul, Amsterdam, Frankfurt. We know international airline timelines and last-minute boarding urgency." },
    { icon: "ri-building-2-line", title: "Convention & Trade Show Ready", desc: "22,000+ conventions annually. We understand short-notice exhibitor travel, international delegate passport needs, and the chaos of trade show season." },
    { icon: "ri-graduation-cap-line", title: "UNLV + Hospitality Workforce", desc: "UNLV study abroad programs, hospitality management internships on three continents, entertainment production crews deploying internationally — we guide everyone through." },
  ],
  internalLinks: [
    { name: "Emergency passport services in Henderson NV", route: "/cities/henderson-nv" },
    { name: "Fast passport renewal in Reno", route: "/cities/reno" },
    { name: "Expedited passport help in Sparks", route: "/cities/sparks" },
    { name: "Urgent passport services in Los Angeles", route: "/los-angeles" },
    { name: "Same-day passport help in San Diego", route: "/san-diego" },
    { name: "Passport courier services in Phoenix area", route: "/states/arizona" },
  ],
  fpcOfficeAddress: "11000 Wilshire Blvd Suite 1000, Los Angeles CA 90024",
  fpcOfficeNote: "Fast Passport Center serves Las Vegas via secure registered courier with reserved submission access at U.S. Department of State processing facilities. Our registered couriers hand-deliver your documents — meaning Las Vegas travelers get faster results without the 270-mile drive to the Los Angeles Passport Agency. Ship from any UPS Store, FedEx Office, or post office location across the Las Vegas Valley and Clark County.",
  fpcOfficeDistance: "Serving Las Vegas, Henderson, Summerlin, North Las Vegas, Spring Valley, Paradise, Enterprise, Boulder City, and all Clark County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Las Vegas and the entire Clark County region. From the Strip to Summerlin, from Henderson to North Las Vegas, from Spring Valley to Boulder City — we serve the Las Vegas Valley's 2.3 million residents and the 40 million annual visitors who sometimes discover passport issues mid-trip. Our courier service eliminates the need to drive 270 miles to the Los Angeles Passport Agency.",
  nearbyCitiesIntro: "We serve all Las Vegas neighborhoods and nearby Southern Nevada cities including Henderson, North Las Vegas, Summerlin, Spring Valley, Paradise, Enterprise, Boulder City, Mesquite, and Pahrump. We also serve Las Vegas visitors who discover urgent passport issues during their stay — a surprisingly common scenario in a city built on spontaneous experiences.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Las Vegas as simple as possible — with the speed and reliability convention exhibitors, entertainment professionals, and Southern Nevada families demand. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Las Vegas travelers complete everything online and ship documents overnight — no office visit required.",
  mistakesIntro: "Las Vegas travelers face unique passport challenges — from convention season urgencies to the 270-mile agency gap to international entertainment production deployments. Here are the most common mistakes we see from the Las Vegas Valley.",
  testimonialsIntro: "Las Vegas travelers — from Strip hospitality professionals to Summerlin families to convention exhibitors — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Las Vegas? Here are the most common ones we hear from Clark County travelers and convention delegates.",
  statePageRoute: "/states/nevada",
  statePageName: "Nevada",
  servicesIntro: "Whether you need a renewal before your LAS flight to London, an emergency passport because CES starts in four days, or a first-time passport for a UNLV student heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.nv.gov",
  dmvLabel: "Nevada DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Nearest agency is Los Angeles (270 miles away via I-15)",
        "Expect to wait all day or return next day",
        "Bereavement or medical crisis documentation required",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "CES exhibitor flying to Tokyo tomorrow? Convention delegate with a passport that expired last month? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Las Vegas-area travelers with imminent departures from Harry Reid International.",
      bullets: ["As fast as 24 hours", "Reserved courier submission", "Flight verification support"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Las Vegas residents renew fast — no agency visit required for most renewals. Perfect for Strip hospitality professionals, Summerlin families, and convention industry workers preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight from any UPS in Las Vegas", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants need an in-person acceptance clerk visit. We guide Las Vegas residents through the process — from the Strip to Summerlin to Boulder City — with step-by-step instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance facility guidance across Clark County", "Expedited processing after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Lost your passport in a Las Vegas hotel? Left it in a taxi on the Strip? It happens more than you would think. We guide you through DS-64 and replacement processing so your departure is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Emergency timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. Vegas families — we provide clear checklists so your international Disney vacation or family reunion abroad stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Las Vegas is the wedding capital of the world — 80,000+ marriages annually. After marriage, divorce, or a legal name change, we assist with corrected passports so your travel documents match your new name.",
      bullets: ["Marriage certificate guidance", "Clark County marriage record expertise", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Entertainment industry professionals traveling internationally while primary passport is in visa processing for Macau, Dubai, or London productions? Frequent convention exhibitors hitting three continents in one month? Second passport keeps you moving.",
      bullets: ["Frequent traveler solution", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Poolside water damage at a Strip resort? Passport survived a Vegas night out but looks like it shouldn't have? Damaged passport replacement is faster than you think — we get you sorted before your return flight home.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Vegas residents making weekend trips to Cancun or cruising to the Bahamas — we expedite passport card applications with same courier service.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Las Vegas NV", description: "Urgent passport processing for Las Vegas travelers with immediate departure needs from Harry Reid International Airport." },
    { name: "Expedited Passport Renewal Las Vegas NV", description: "Fast passport renewal for Las Vegas Nevada residents with a previously-issued passport." },
    { name: "First-Time Passport Las Vegas NV", description: "New passport application services for Las Vegas Nevada residents applying for their first passport." },
    { name: "Child Passport Las Vegas NV", description: "Minor passport services for Las Vegas Nevada families with children under 16." },
    { name: "Name Change Passport Las Vegas NV", description: "Passport name correction after marriage at Clark County, divorce, or legal name changes for Las Vegas residents." },
    { name: "Second Passport Las Vegas NV", description: "Second passport services for Las Vegas entertainment professionals, convention exhibitors, and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Derek M.",
      location: "Summerlin, NV",
      rating: 5,
      text: "My flight to Tokyo was in 3 days and I realized my passport expired. Fast Passport Center got me a new one in 36 hours. Absolutely saved my international trip from Harry Reid.",
      service: "Emergency Passport",
    },
    {
      name: "Priya S.",
      location: "Henderson, NV",
      rating: 5,
      text: "Needed passport renewal for a Cancun vacation. The process was seamless, they reviewed all my documents, and I had my passport in 4 days. Would 100% use again.",
      service: "Passport Renewal",
    },
    {
      name: "James R.",
      location: "Las Vegas, NV",
      rating: 5,
      text: "Lost my passport the week before my honeymoon to Italy. They walked me through the DS-64 process and got me a replacement in 2 days. Unbelievable turnaround.",
      service: "Lost Passport",
    },
    {
      name: "Karen T.",
      location: "North Las Vegas, NV",
      rating: 5,
      text: "As a convention exhibitor hitting 15+ international shows a year, I can't afford delays. Fast Passport Center is my go-to every time. They're professional, fast, and always reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "lv-1",
      name: "Las Vegas Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1001 E Sunset Rd",
      city: "Las Vegas",
      state: "NV",
      zip: "89119",
      phone: "(702) 361-9280",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Near Harry Reid International Airport",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility near the airport. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "lv-2",
      name: "North Las Vegas Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2900 Losee Rd",
      city: "North Las Vegas",
      state: "NV",
      zip: "89030",
      phone: "(702) 399-8188",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from North Las Vegas downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves North Las Vegas and Sunrise Manor. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "lv-3",
      name: "Henderson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 Water St",
      city: "Henderson",
      state: "NV",
      zip: "89015",
      phone: "(702) 564-9901",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from Henderson downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Henderson and Boulder City area. Call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "lv-4",
      name: "Clark County Government Center",
      type: "County Clerk Passport Acceptance",
      address: "500 S Grand Central Pkwy",
      city: "Las Vegas",
      state: "NV",
      zip: "89155",
      phone: "(702) 455-4336",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "0.5 miles from downtown Las Vegas",
      website: "https://www.clarkcountynv.gov/",
      websiteLabel: "Clark County Clerk",
      notes: "Full-service government center with extended hours. Accepts walk-ins but appointments recommended.",
      icon: "ri-government-line",
    },
    {
      id: "lv-5",
      name: "Summerlin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10100 W Charleston Blvd",
      city: "Las Vegas",
      state: "NV",
      zip: "89135",
      phone: "(702) 228-8800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "In the Summerlin community center area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for west Las Vegas and Summerlin residents. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "lv-6",
      name: "Nevada DMV — Las Vegas",
      type: "State DMV Passport Acceptance",
      address: "8250 W Flamingo Rd",
      city: "Las Vegas",
      state: "NV",
      zip: "89147",
      phone: "(702) 486-4368",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "West Las Vegas near Spring Valley",
      website: "https://dmv.nv.gov/",
      websiteLabel: "Nevada DMV",
      notes: "Select Nevada DMV locations offer passport acceptance. Call ahead to confirm service availability.",
      icon: "ri-car-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, limited slots, often booked solid", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 270-mile drive to Los Angeles Passport Agency via I-15", fpc: "Most Las Vegas travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Same-day if approved for life-or-death only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options for any travel scenario" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay at agency window", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee of availability", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle 270-mile drive and all logistics", fpc: "Best price guarantee — 30–100% less than FedEx, Staples & resellers" },
    { feature: "Las Vegas-Specific Expertise", agency: "Generic — no convention, entertainment, or hospitality industry knowledge", fpc: "Full Las Vegas/convention/entertainment/UNLV knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Convention Season Panic",
      description: "CES, SEMA, MAGIC, NAB — the largest trade shows on Earth happen in Las Vegas. International exhibitors and delegates often book flights, then realize their passport expired. With 135,000+ attendees at CES alone, this is a recurring crisis. We handle convention passport urgencies as a specialty.",
    },
    {
      icon: "ri-road-map-line",
      title: "Assuming There Is a Las Vegas Passport Agency",
      description: "Despite being a global destination city with 50M+ airport passengers, Nevada has ZERO passport agencies. The nearest is Los Angeles — 270 miles away on unpredictable I-15 desert highway traffic. Many discover this the hard way.",
    },
    {
      icon: "ri-image-line",
      title: "Casino Photo Booth Failures",
      description: "Strip casino photo booths and drugstore photo centers often produce photos that do not meet State Department standards — wrong sizing, non-white backgrounds, or poor lighting. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-hotel-line",
      title: "Visitor Passport Emergencies During Stay",
      description: "Las Vegas hosts 40 million visitors annually. Lost passports in hotel rooms, water damage poolside, theft on the Strip — these happen every single day. Out-of-state visitors discover their passport is unusable for their return international flight.",
    },
    {
      icon: "ri-parent-line",
      title: "Wedding Name Change — Then Flying Internationally",
      description: "Las Vegas issues 80,000+ marriage licenses per year. Many couples get married and immediately fly internationally for their honeymoon — but their passport name does not match their ticket. This creates an immediate crisis at the LAS check-in counter.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or hotel room." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your convention, entertainment, or family travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option from any UPS Store, FedEx Office, or post office across the Las Vegas Valley — no 270-mile drive needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to the Los Angeles Passport Agency or wait for a government appointment." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping — just certainty for your international departure from Harry Reid International Airport." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Las Vegas?", a: "Fast Passport Center offers emergency passport processing in Las Vegas in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, bypassing standard mail delays. Since Nevada has no local passport agency — the nearest is 270 miles away in Los Angeles — this courier service is the fastest reliable option for Las Vegas travelers." },
    { q: "Does Nevada have a passport agency near Las Vegas?", a: "No. Nevada does not have a regional passport agency. The nearest agency is the Los Angeles Passport Agency, approximately 270 miles away via I-15. This is one of the largest agency gaps in the country — especially given that Las Vegas is a global destination with 50M+ annual airport passengers. Most Las Vegas travelers use Fast Passport Center's courier service to avoid the 270-mile drive." },
    { q: "I am a convention exhibitor and CES starts in four days — my passport expired. What can I do?", a: "This is one of the most common scenarios we handle in Las Vegas. Convention delegates and exhibitors often discover passport issues days before the show. Fast Passport Center's 24–48 hour emergency courier processing is specifically designed for this exact situation. We have handled urgent passport needs for CES, SEMA, MAGIC, NAB, AWS re:Invent, and countless other Las Vegas trade show delegates." },
    { q: "I am visiting Las Vegas and lost my passport at my hotel. I have an international flight home in three days. Help?", a: "This happens daily in Las Vegas — 40 million annual visitors means lost passports are a constant reality. We can process a replacement passport for out-of-state visitors. Contact us immediately and we will walk you through the emergency replacement process. In many cases, we can get your replacement passport completed before your scheduled return flight." },
    { q: "Where can I get a fast passport renewal in Las Vegas?", a: "Fast Passport Center offers fast passport renewal in Las Vegas with no office visit required. We serve all Las Vegas neighborhoods including Summerlin, Henderson, North Las Vegas, Spring Valley, and Paradise. Simply complete your application online, ship your documents using our prepaid overnight label from any UPS location in the Las Vegas Valley, and our couriers handle the rest." },
    { q: "Can I get a same-day passport in Las Vegas?", a: "Same-day passports are only available at regional passport agencies — and the nearest one to Las Vegas is in Los Angeles, 270 miles away. Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option available to Las Vegas and Clark County residents without driving to Los Angeles." },
    { q: "Where are the closest passport acceptance facilities in Las Vegas?", a: "Popular Las Vegas acceptance facilities include the Las Vegas Main Post Office (89119), North Las Vegas Post Office (89030), Henderson Post Office (89015), Clark County Government Center (89155), and the Summerlin Post Office (89135). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I need a child's passport in Las Vegas?", a: "Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Las Vegas families through the entire process and help schedule acceptance clerk appointments at the most convenient Clark County facility." },
    { q: "How much does expedited passport service cost in Las Vegas?", a: "Government fees are $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote. Our total cost is typically 30–100% less than FedEx, Staples, and other third-party resellers." },
    { q: "I got married in Las Vegas and my passport still has my old name. Can I still fly internationally for my honeymoon?", a: "This is one of the most common scenarios we see at Harry Reid International Airport. If your passport name does not match your airline ticket, you will be denied boarding. If you just got married and need to travel immediately, fly under your passport name (not your new married name) — otherwise, we can help expedite a name change passport correction. Call us before your departure date." },
    { q: "Do you help with passport photos in Las Vegas?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, FedEx Office, and UPS Store locations in Las Vegas offer passport photo services. We review your photos before submission to ensure they meet State Department standards — casino photo booths and some drugstore photos often fail." },
    { q: "What about entertainment industry professionals working international productions?", a: "Las Vegas is the entertainment capital of the world. Cirque du Soleil, residencies, touring productions, and international performers frequently need passports on short notice for Macau, Dubai, London, and other global entertainment hubs. We understand the unique constraints of production schedules and work-permit timing. Our 24–48 hour emergency processing keeps your production on schedule." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Las Vegas Residents",
    intro: "Las Vegas operates on a completely different rhythm from any other American city — a 24/7 global destination with a convention-driven economy, an entertainment industry that never sleeps, and an airport that handles 50 million passengers a year. Here is what Las Vegas travelers need to know about passport timing.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "LAS — Harry Reid International Airport",
        subtitle: "50M+ annual passengers, nonstop to 150+ destinations worldwide",
        description: "Harry Reid International is one of America's busiest international gateways, with nonstop service to London, Tokyo, Seoul, Amsterdam, Mexico City, Frankfurt, Panama City, and dozens of other global destinations. The airport serves as the primary international departure point for all of Southern Nevada and parts of Arizona and Utah. International passengers from LAS are a diverse mix — convention delegates, leisure travelers, entertainment industry professionals, and international visitors returning home. The airport's global reach means passport urgencies arise constantly across every traveler profile.",
        tip: "LAS international flights — especially to Asia and Europe — often require 6 months of passport validity beyond your return date. A passport with 5 months left is effectively expired for your Tokyo or London flight.",
      },
      {
        icon: "ri-building-2-line",
        title: "Convention & Trade Show Season — The Engine of Las Vegas Travel",
        subtitle: "22,000+ conventions annually, 6M+ delegates, year-round international demand",
        description: "Las Vegas is the undisputed convention capital of North America. CES (135,000+ attendees), SEMA, MAGIC Fashion, NAB Show, AWS re:Invent, the International Builders' Show, and thousands more fill the Las Vegas Convention Center, Sands Expo, Mandalay Bay Convention Center, and every major resort property. International exhibitors and delegates from every continent fly in on tight schedules — often with 1–2 weeks' notice. Convention-driven passport urgencies spike dramatically during major show weeks, and many international delegates only discover passport issues days before their flight.",
        tip: "Convention exhibitors should verify passport validity the moment booth registration is confirmed — not the week before the show. We see the same crisis unfold during every major Las Vegas convention.",
      },
      {
        icon: "ri-movie-2-line",
        title: "Entertainment Industry & International Production",
        subtitle: "Residencies, touring productions, Cirque du Soleil, global entertainment workforce",
        description: "Las Vegas is the global capital of live entertainment. Cirque du Soleil alone runs multiple resident shows with international casts from 50+ countries. Major recording artists stage residencies that bring international crews and production teams. Entertainment professionals deploy to Macau, Dubai, London, and Singapore for sister productions on short notice. The entertainment industry's global nature means performers, technicians, and production managers frequently need passports renewed or replaced on extremely compressed timelines — often with work visa requirements that add another layer of complexity.",
        tip: "Entertainment professionals traveling internationally for production work should maintain a second passport. Many countries require 6 months of validity for work visas — waiting until the last minute is a production-delaying risk.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "UNLV International Programs & Hospitality Workforce",
        subtitle: "William F. Harrah College of Hospitality, 400+ study abroad programs, 300K+ hospitality employees",
        description: "UNLV's Harrah College of Hospitality is the top-ranked hospitality management program in the world, sending students and faculty to internships, conferences, and research programs on every continent. UNLV also offers 400+ study abroad programs across 65+ countries. Additionally, the Las Vegas Strip employs over 300,000 hospitality workers — many in management roles that require international travel for training, brand inspections, and property openings in Macau, Singapore, Dubai, and beyond. First-time passport applicants in this workforce frequently need expedited processing to meet training program start dates.",
        tip: "UNLV students should apply for passports at least 10 weeks before study abroad program orientation. First-time applicants must visit an acceptance facility in person — we guide students through the best local option with the shortest wait times.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The 270-Mile Agency Gap — Nevada Has No Passport Agency",
      description: "Despite being one of the most visited cities on Earth with 50 million annual airport passengers, Las Vegas — and the entire state of Nevada — has ZERO passport agencies. The nearest regional passport agency is the Los Angeles Passport Agency, 270 miles away on I-15. For travelers needing emergency same-day service at a government agency, that means a 4–5 hour drive each way through desert terrain. This is one of the largest passport agency gaps in the United States, and it affects every Las Vegas resident and visitor who discovers an urgent passport need.",
    },
  },
  destinations: {
    title: "Where Las Vegas Travelers Go — And Why Passports Get Urgent",
    intro: "Harry Reid International's global route network and Las Vegas' unique economy create distinct international travel patterns. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "38%", label: "of Las Vegas expedited requests are convention or trade show-related with under 2 weeks notice" },
      { stat: "1–2 Weeks", label: "average lead time Las Vegas travelers have from trip booking to international departure" },
      { stat: "Jan–Mar", label: "peak season when CES, MAGIC, spring break, and convention season collide simultaneously" },
      { stat: "24 Hours", label: "shortest turnaround we have accommodated for a CES exhibitor departing to Tokyo Narita" },
    ],
    destinations: [
      { name: "Mexico", context: "Cancun and Riviera Maya resorts, Mexico City business, Cabo San Lucas leisure — all with LAS nonstop service. Most international flights from Harry Reid go to Mexico.", urgency: "Spring break bookings peak January through March; last-minute all-inclusive deals booked 2–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "LAS-London Heathrow nonstop on British Airways and Virgin Atlantic. Convention business, entertainment industry, and leisure travel drive consistent demand.", urgency: "Business trips and production deployments booked 2–3 weeks out with fixed dates", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "LAS-Tokyo Narita nonstop on multiple carriers. Gaming industry partnerships, tech convention delegates, entertainment production exchanges between Las Vegas and Macau/Tokyo entertainment markets.", urgency: "Convention and gaming industry travel often has 1–2 week booking windows", icon: "ri-map-pin-2-line" },
      { name: "Germany & Netherlands", context: "LAS-Frankfurt and LAS-Amsterdam nonstop routes. European convention delegates, hospitality management exchanges, entertainment industry partnerships.", urgency: "Trade show delegate travel booked 3–4 weeks out — Frankfurt and Amsterdam serve as European hub connections", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "LAS-Toronto, LAS-Vancouver, LAS-Montreal nonstops. Cross-border business travel, entertainment industry connections, family visits.", urgency: "Business travel and entertainment production crews booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Central America", context: "LAS-Panama City nonstop on Copa Airlines connecting to all of Latin America. Cruise departures from Los Angeles and Miami. Resort vacations and spring break travel.", urgency: "Last-minute cruise and all-inclusive deals create 2–3 week passport urgencies", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Nevada Service Areas",
    crossLinksDesc: "We serve travelers across Nevada with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Reno", route: "/cities/reno" },
      { name: "Sparks", route: "/cities/sparks" },
      { name: "Carson City", route: "/cities/carson-city" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Las Vegas Strip", address: "3758 Las Vegas Blvd S, Las Vegas, NV 89109", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Summerlin", address: "10120 W Charleston Blvd, Las Vegas, NV 89135", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Downtown Las Vegas", address: "301 N Main St, Las Vegas, NV 89101", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Henderson", address: "101 N Stephanie St, Henderson, NV 89014", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — North Las Vegas", address: "1807 W Craig Rd, North Las Vegas, NV 89032", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Henderson", address: "590 College Dr, Henderson, NV 89015", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Summerlin", address: "8880 W Charleston Blvd, Las Vegas, NV 89117", hours: "Mon–Sun: 8AM–10PM" },
    { name: "UPS Store — Spring Valley", address: "5051 S Fort Apache Rd, Las Vegas, NV 89148", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    {
      name: "Nevada DMV — West Flamingo",
      address: "8250 W Flamingo Rd, Las Vegas, NV 89147",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and Nevada driver's license renewals. Appointment required.",
      featured: true,
    },
    {
      name: "Nevada DMV — Henderson",
      address: "2250 N Green Valley Pkwy, Henderson, NV 89014",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service Henderson DMV. Serves Green Valley, Anthem, and East Henderson.",
      featured: false,
    },
    {
      name: "Nevada DMV — North Las Vegas",
      address: "2501 E Cheyenne Ave, North Las Vegas, NV 89030",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Serves North Las Vegas and Sunrise Manor. Online appointment booking available.",
      featured: true,
    },
    {
      name: "Nevada DMV — Summerlin",
      address: "9530 Del Webb Blvd, Las Vegas, NV 89134",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Convenient for Summerlin and western Las Vegas residents. REAL ID processing.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LAS",
      name: "Harry Reid International Airport",
      distance: "5 miles from the Las Vegas Strip",
      address: "5757 Wayne Newton Blvd, Las Vegas, NV 89119",
      note: "The primary international airport for Las Vegas and all of Southern Nevada. 50M+ passengers annually. Nonstop service to London, Tokyo, Seoul, Amsterdam, Frankfurt, Mexico City, Panama City, and 150+ destinations. Major hub for international leisure, convention, and entertainment industry travel.",
      flightUrl: "https://www.harryreidairport.com/",
      flightLabel: "Harry Reid Airport",
      featured: true,
    },
    {
      code: "BOU",
      name: "Boulder City Municipal Airport",
      distance: "25 miles from downtown Las Vegas",
      address: "1 Airport Rd, Boulder City, NV 89005",
      note: "Small general aviation airport serving Boulder City. Grand Canyon tour flights depart from here. No commercial international service.",
      flightUrl: "https://www.bcity.com/airport",
      flightLabel: "Boulder City Airport",
      featured: false,
    },
    {
      code: "LAX",
      name: "Los Angeles International Airport",
      distance: "270 miles from Las Vegas via I-15",
      address: "1 World Way, Los Angeles, CA 90045",
      note: "Alternative hub for extended international routes not served from LAS. Also home to the nearest regional passport agency — the Los Angeles Passport Agency for emergency appointments.",
      flightUrl: "https://www.flylax.com/",
      flightLabel: "LAX Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Southern Nevada Health District Vital Records. Online, mail, or in-person at the main clinic in Las Vegas. Serving Clark County and all Las Vegas communities.",
      url: "https://www.southernnevadahealthdistrict.org/programs/vital-records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Southern Nevada Health District Vital Records. Required for estate, legal, and survivor benefit matters in Clark County.",
      url: "https://www.southernnevadahealthdistrict.org/programs/vital-records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from the Clark County Clerk Marriage License Bureau. Las Vegas is the marriage capital of the world — 80,000+ licenses issued annually. Certified copies available for name change passport applications.",
      url: "https://www.clarkcountynv.gov/government/elected_officials/county_clerk/marriage_licenses.php",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Clark County District Court. Required for name change passport corrections and legal documentation following divorce in Clark County.",
      url: "https://www.clarkcountycourts.us/",
    },
  ],
};